import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function DeleteAccount() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const del = async (e) => {
    e?.preventDefault?.();
    setBusy(true);
    try {
      await api.delete("/auth/me");
      try { localStorage.removeItem(`dietflix_onb_${user?.user_id || "anon"}`); } catch {}
      toast.success("Account eliminato");
      await logout();
      navigate("/");
    } catch {
      toast.error("Impossibile eliminare l'account. Riprova.");
      setBusy(false);
    }
  };

  return (
    <div className="mt-8 border border-destructive/30 rounded-2xl p-5 bg-destructive/5" data-testid="danger-zone">
      <h3 className="font-semibold text-destructive flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" /> Zona pericolosa
      </h3>
      <p className="text-sm text-muted-foreground mt-1">
        Elimina definitivamente il tuo account e tutti i dati collegati (dieta, analisi, peso, ricette, integratori, notifiche). Questa azione è irreversibile.
      </p>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="destructive" size="sm" className="mt-3" data-testid="delete-account-button">
            <Trash2 className="h-4 w-4 mr-2" /> Elimina account
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent data-testid="delete-account-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Eliminare definitivamente l'account?</AlertDialogTitle>
            <AlertDialogDescription>
              Tutti i tuoi dati verranno cancellati e non potranno essere recuperati. Se hai un abbonamento attivo, ricordati di annullarlo prima.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="delete-account-cancel">Annulla</AlertDialogCancel>
            <AlertDialogAction
              onClick={del}
              disabled={busy}
              className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
              data-testid="delete-account-confirm"
            >
              {busy ? "Eliminazione…" : "Elimina definitivamente"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
